
import { cn } from "@/lib/utils";

interface OnboardingQuestionProps {
  questionText: string;
  options: string[];
  selectedAnswer: string;
  onSelect: (answer: string) => void;
  onBrowse?: () => void;
  showBrowseOption?: boolean;
}

export const OnboardingQuestion = ({
  questionText,
  options,
  selectedAnswer,
  onSelect,
  onBrowse,
  showBrowseOption = false,
}: OnboardingQuestionProps) => {
  if (!Array.isArray(options) || options.length === 0) {
    console.error("OnboardingQuestion: options must be a non-empty array");
    return null;
  }

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center p-4 pb-20 md:pb-4 bg-background">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h3 className="text-2xl md:text-3xl font-semibold mb-8">{questionText}</h3>
        </div>
        
        <div className="grid grid-cols-1 gap-4">
          {options.map((option, index) => (
            <button
              key={index}
              className={cn(
                "p-6 rounded-2xl border transition-all duration-200",
                "flex items-center justify-center text-center min-h-[80px]",
                "text-lg md:text-xl font-medium shadow-sm hover:shadow-md",
                selectedAnswer === option
                  ? "border-primary bg-primary/5 text-primary"
                  : "border-border bg-background hover:border-primary/50"
              )}
              onClick={() => onSelect(option)}
            >
              {option}
            </button>
          ))}
        </div>
        
        {showBrowseOption && (
          <div className="text-center pt-6">
            <button
              onClick={onBrowse}
              className="text-primary hover:underline text-lg"
            >
              I'd like to browse
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
